import { put } from 'redux-saga/effects'
import { fetchActiveDepartmentsAction } from '../../handles'
import { fetchActiveDepartments, FetchActiveDepartmentsResponse } from '../_http/department'

export function* fetchActiveDepartmentsSaga(action: ReturnType<typeof fetchActiveDepartmentsAction.request>) {
  try {
    const { companyId } = action.payload
    const response: FetchActiveDepartmentsResponse = yield fetchActiveDepartments({ companyId })
    yield put(fetchActiveDepartmentsAction.success({ departments: response.departments }))
  } catch (error) {
    yield put(fetchActiveDepartmentsAction.failure())
  }
}
